"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.YearsList = void 0;
var react_1 = __importStar(require("react"));
var system_1 = require("../../system");
var Divider_1 = require("../Divider");
var Check_1 = require("../icons/Check");
var List_1 = require("../List");
var ListItem_1 = require("../ListItem");
var utils_1 = require("./utils");
var YEARS = (0, utils_1.geyYears)();
var useYearsListStyles = (0, system_1.makeStyles)(function (theme) { return ({
    root: {
        width: 'inherit',
        height: 240,
        paddingTop: 24,
    },
    listRoot: {
        display: 'flex',
        justifyContent: 'center',
    },
    list: {
        width: 240,
    },
    checkIcon: {
        color: theme.go.schemes.components.lists.selectedTextColor,
    },
}); });
var asIs = function (x) { return "".concat(x); };
function YearsList(_a) {
    var year = _a.year, onItemClick = _a.onItemClick;
    var _b = useYearsListStyles(), root = _b.root, list = _b.list, listRoot = _b.listRoot, checkIcon = _b.checkIcon;
    var selectedItems = (0, react_1.useMemo)(function () { return [year]; }, [year]);
    var renderItem = (0, react_1.useCallback)(function (item, selected) { return (react_1.default.createElement(ListItem_1.ListItem, { title: "".concat(item), selected: selected, onClick: function () { return onItemClick(item); }, endElement: selected ? react_1.default.createElement(Check_1.CheckIcon, { className: checkIcon }) : undefined })); }, [checkIcon, onItemClick]);
    return (react_1.default.createElement("div", { className: root },
        react_1.default.createElement(Divider_1.Divider, null),
        react_1.default.createElement(List_1.List, { items: YEARS, getId: asIs, selectedItems: selectedItems, classes: { list: list, root: listRoot }, renderItem: renderItem }),
        react_1.default.createElement(Divider_1.Divider, null)));
}
exports.YearsList = YearsList;
